var map = {
	"./ban-icon.svg": 10861,
	"./check-icon.svg": 13676,
	"./info-icon.svg": 16924,
	"./layers-icon.svg": 70650,
	"./list-icon.svg": 90072,
	"./spinner-icon.svg": 74625,
	"./wallet-icon.svg": 56137,
	"./warning-icon.svg": 87440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96434;